import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {shareReplay} from 'rxjs/operators';
import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {environment} from 'src/environments/environment';
import {NameValueCodeDTO} from '../models/NameValueCodeDTO';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  private url = environment.baseUrl + '/lookup';
  private cache = new Map<string, Observable<NameValueDTO[]>>();
  private cacheWithCode = new Map<string, Observable<NameValueCodeDTO[]>>();

  constructor(private httpClient: HttpClient) {
  }

  getListOfLookupValues(entityName: string): Observable<NameValueDTO[]> {
    if (!this.cache.has(entityName)) {
      this.cache.set(entityName, this.httpClient.get<NameValueDTO[]>(this.url + '/' + entityName).pipe(shareReplay(1)));
    }
    return this.cache.get(entityName)!;
  }

  getListOfLookupValuesWithCode(entityName: string): Observable<NameValueCodeDTO[]> {
    if (!this.cacheWithCode.has(entityName)) {
      this.cacheWithCode.set(entityName, this.httpClient.get<NameValueCodeDTO[]>(this.url + '/' + entityName).pipe(shareReplay(1)));
    }
    return this.cacheWithCode.get(entityName)!;
  }
}
